import React, { useState, useEffect } from "react";
import { FaCheck, FaTrash } from "react-icons/fa";
import StyleModal from "../../Modals/StyleModal";
import { listFoldersFromS3, deleteFromS3 } from "../../../config/aws";
import { USER_NAME } from "../../../constant";
import { generatePresignedUrl } from "../../../config/aws";


const defaultStyles = [
    { name: "Modern", src: "https://storage.googleapis.com/a1aa/image/lKJJU1Tvr8efZzmetn7uawtNP2jgI7Icn1Utc1lk1pc.jpg" },
    { name: "Vintage", src: "https://storage.googleapis.com/a1aa/image/0nzNLeujLfK1TdjBJMqgUjvNIf-kGNagxRMeOaSvjK4.jpg" },
    { name: "Minimalist", src: "https://storage.googleapis.com/a1aa/image/fI2fr_CXBzrVltm3lRt-aMzHBWij0v9rxkpYp4PEuvM.jpg" },
    { name: "Industrial", src: "https://storage.googleapis.com/a1aa/image/z2rHV43CVi5maiJKa5-yACmjmQMG_bARdeT8hElU9Yc.jpg" },
    { name: "Scandinavian", src: "https://storage.googleapis.com/a1aa/image/lKJJU1Tvr8efZzmetn7uawtNP2jgI7Icn1Utc1lk1pc.jpg" },
    { name: "Bohemian", src: "https://storage.googleapis.com/a1aa/image/0nzNLeujLfK1TdjBJMqgUjvNIf-kGNagxRMeOaSvjK4.jpg" },
    { name: "Contemporary", src: "https://storage.googleapis.com/a1aa/image/z2rHV43CVi5maiJKa5-yACmjmQMG_bARdeT8hElU9Yc.jpg" },
    { name: "Traditional", src: "https://storage.googleapis.com/a1aa/image/lKJJU1Tvr8efZzmetn7uawtNP2jgI7Icn1Utc1lk1pc.jpg" },
    { name: "Rustic", src: "https://storage.googleapis.com/a1aa/image/0nzNLeujLfK1TdjBJMqgUjvNIf-kGNagxRMeOaSvjK4.jpg" },
];

const StyleGallery = ({ onSelectStyle, onClose, setCreditsAvailable }) => {
    const [activeTab, setActiveTab] = useState("myStyles");
    const [selectedStyles, setSelectedStyles] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [myStyles, setMyStyles] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    // useEffect(() => {
    //     const storedStyles = sessionStorage.getItem('uploadedStyles');
    //     if (storedStyles) {
    //         const parsedStyles = JSON.parse(storedStyles);
    //         setMyStyles(parsedStyles);
    //     }
    // }, []);

    // Fetch style folders from S3 when component mounts

    const fetchStyles = async () => {
        try {
            const styleFolders = await listFoldersFromS3(`USERS/${USER_NAME}/all_styles/`);
            // Transform folder names into style objects
            const styles = styleFolders.map(folderName => ({
                name: folderName,
                src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTUUGMO8v1YxhmAmNfQ_3xg-LGZ8c3emfX6_A&s" // Default image
            }));

            // Fetch the thumbnail image for each style folder
            const stylesWithImages = await Promise.all(styles.map(async (style) => {
                try {
                    const thumbnailPath = `USERS/${USER_NAME}/all_styles/${style.name}/user_style_images/thumbnail.webp`;
                    const preSignedURL = await generatePresignedUrl(thumbnailPath);
                    style.src = preSignedURL;
                    return style;
                } catch (error) {
                    console.error(`Error fetching thumbnail for style ${style.name}:`, error);
                    return style;
                }
            }));
            setMyStyles(stylesWithImages);
        } catch (error) {
            console.error("Error fetching style folders:", error);
        }
    };

    useEffect(() => {
        fetchStyles();
    }, []);

    const toggleStyleSelection = (index) => {
        setSelectedStyles(index);
    };

    const handleSelectStyle = () => {
        if (selectedStyles !== null) {
            const selectedStyle = activeTab === "default" ? filteredStyles[selectedStyles] : filteredMyStyles[selectedStyles];
            onSelectStyle(selectedStyle);
            onClose();
        }
    };

    const filteredStyles = defaultStyles.filter(style =>
        style.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const filteredMyStyles = myStyles.filter(style =>
        style.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const renderStyleGrid = (styleList) => (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
            {styleList.map((style, index) => (
                <div
                    key={index}
                    className="flex flex-col cursor-pointer group m-0.5"
                    onClick={() => toggleStyleSelection(index)}
                >
                    <div className="relative overflow-hidden aspect-square w-28 h-28">
                        <img
                            src={style.src || style.preview}
                            alt={style.name}
                            className={`w-full h-full object-cover rounded-xl transition-opacity ${selectedStyles === index ? 'opacity-75' : ''}`}
                            title={style.name}
                        />
                        {selectedStyles === index && (
                            <div className="absolute top-1 right-1 bg-green-500 rounded-full p-1">
                                <FaCheck className="text-white text-xs" />
                            </div>
                        )}
                    </div>
                    <div className="text-center text-black font-semibold text-xs mt-1 w-28 truncate">{style.name}</div>
                </div>
            ))}
            {styleList.length === 0 && (
                <div className="col-span-full text-center text-gray-500">
                    No styles found matching your search.
                </div>
            )}
        </div>
    );

    return (
        <>
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-4xl  h-full flex flex-col">
                {/* Tabs */}
                <div className="flex justify-between items-center border-b border-gray-200 pb-2 mb-4">
                    <div className="flex w-full justify-between">
                        {/* <button
                            className={`py-2 px-2 font-semibold border-b-2 transition-colors flex-1 ${activeTab === "default"
                                ? "text-purple-600 border-purple-600"
                                : "text-black border-transparent"
                                }`}
                            onClick={() => setActiveTab("default")}
                        >
                            Default Styles
                        </button> */}

                        <button
                            className={`py-2 px-2 font-semibold border-b-2 transition-colors flex-1 ${activeTab === "myStyles"
                                ? "text-purple-600 border-purple-600"
                                : "text-black border-transparent"
                                }`}
                            onClick={() => setActiveTab("myStyles")}
                        >
                            My Styles
                        </button>
                    </div>
                </div>
                <div className="relative mb-6">
                    <input
                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
                        placeholder="Search for styles"
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <i className="fas fa-search absolute left-3 top-3 text-gray-400">
                    </i>
                </div>

                {/* Style Display */}
                <div className="flex-1 overflow-y-auto pr-2 -mr-2">
                    {activeTab === "default" ? (
                        renderStyleGrid(filteredStyles)
                    ) : (
                        <>
                            <div className="text-center mb-4 py-2 px-6 bg-gray-50 rounded-xl border border-dashed border-gray-300 shadow-inner">
                                {myStyles.length === 0 && (<p className="text-gray-600 font-medium mb-3 text-lg">No styles found.</p>)}
                                <p className="text-gray-500 mb-2">
                                    Click <button onClick={() => setShowModal(true)} className="text-purple-600 font-semibold hover:text-purple-800 transition-colors duration-300 underline hover:no-underline focus:outline-none">here</button> to add your style!
                                </p>
                            </div>
                            {myStyles.length > 0 && renderStyleGrid(filteredMyStyles)}
                        </>


                    )}
                </div>
                {/* Select Button */}
                {selectedStyles !== null && (
                    <div className="mt-6 flex justify-end">
                        <button
                            onClick={handleSelectStyle}
                            disabled={selectedStyles === null}
                            className={`px-6 py-2 rounded-lg font-semibold transition-all duration-300 ${selectedStyles === null
                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                : 'bg-purple-600 text-white hover:bg-purple-700'
                                }`}
                        >
                            Select Style
                        </button>
                    </div>
                )}
            </div>

            <StyleModal fetchStyles={fetchStyles} isOpen={showModal} onRequestClose={() => setShowModal(false)} setCreditsAvailable={setCreditsAvailable} />
        </>
    );
};

export default StyleGallery; 